export default __webpack_public_path__ + "static/bg-left-d492b023994e7c7931c54410f650e388.png";